import api from '@/api'
import storage from '@/plugins/storage'
import * as types from './types'

export const configuration = {
  namespaced: true,
  state: {
    configuration: JSON.parse(storage.local.getItem(types.CONFIGURATION)) || []
  },
  getters: {
    configuration: state => state.configuration
  },
  actions: {
    getConfigurationValues({ commit }) {
      const key = 'configuration'
      return new Promise((resolve, reject) => {
        api.lookupsZeus(key, { headers: { 'content-type': 'application/json' } })
         .then(response => {
           commit(types.SET_CONFIGURATION, response.data)
           resolve(response)
         })
        .catch(error => reject(error))
      })
    }
  },
  mutations: {
    SET_CONFIGURATION(state, data) {
      storage.local.setItem(types.CONFIGURATION, JSON.stringify(data))
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/configuration/index.js